import * as React from 'react';
import { ContactSupport } from './ContactSupport';
import { Button, type LinkTarget } from '@workspace/ui/common/Buttons/Button';
import { shouldOpenInNewTab } from '@workspace/lib';
import type { PageContactSupportBlock } from './contact-support.types';
import { toVariant } from './lib';
import { SanityImage } from '@workspace/interfaces';

export function PageContactSupport({ block }: { block: PageContactSupportBlock }) {
  const image: SanityImage | undefined = block?.imageLink?.image?.asset
    ? {
        asset: {
          _id: block.imageLink.image.asset._id ?? '',
          _ref: block.imageLink.image.asset._ref ?? '',
          _type: 'reference' as const,
          url: block.imageLink.image.asset.url ?? '',
        },
        crop: block.imageLink.image.crop,
        hotspot: block.imageLink.image.hotspot,
        alt: block.imageLink.image.alt ?? block.imageLink?.alt,
        url: block.imageLink.image.asset.url,
      }
    : undefined;
  const imageAlt = block?.imageLink?.image?.alt ?? block?.imageLink?.alt ?? 'Contact support image';

  const headingText = block?.heading ?? '';
  const descriptionText = block?.description ?? '';

  const contactItems = Array.isArray(block?.contactInfo)
    ? block.contactInfo.map((i) => ({
        title: i?.title,
        icon: i?.icon,
        text: i?.textLink?.text ?? '',
        isBold: i?.textLink?.isBold ?? true,
        href: i?.textLink?.link?.href ?? undefined,
        target: shouldOpenInNewTab(i?.textLink?.link) ? ('_blank' as LinkTarget) : ('_self' as LinkTarget),
        iconImageUrl: i?.icon?.iconImage?.asset?.url ?? i?.iconImage?.asset?.url,
      }))
    : [];

  type ButtonProps = React.ComponentProps<typeof Button>;
  const buttons: (ButtonProps & { href?: string; target?: LinkTarget })[] = block?.ctaButton
    ? [
        {
          variant: toVariant(block.ctaButton.style),
          children: block.ctaButton.label,
          href: block.ctaButton.link?.href,
          target: shouldOpenInNewTab(block.ctaButton?.link) ? '_blank' : '_self',
          className: 'w-full sm:w-auto min-w-[220px] md:min-w-[260px] px-6',
        },
      ]
    : [];

  return (
    <ContactSupport
      heading={headingText}
      description={descriptionText}
      image={image}
      imageAlt={imageAlt}
      contactItems={contactItems}
      button={buttons}
    />
  );
}
